/**
 * Features for product type game.
 */
export enum LicenseGameFeature {
  GAME_WEB = 'game_web',
  GAME_PROMO_WEB = 'game_promo_web',
  GAME_RESULT = 'game_result'
}
